// Vertical rhythm + id anchor for a marketing section, sitting on top of
// SiteContainer (which owns width + horizontal padding). Extracted 2026-08-21
// from identical local Section() helpers in _site+/index.tsx and
// _site+/more.tsx.
//
// Split of concerns:
//   - SiteContainer  -> max-w + px-6 (single source of truth for chrome/pages)
//   - SiteSection    -> py-6 md:py-8 + optional id anchor + wide|narrow
//
// A page that wants a different vertical rhythm (denser hero, wider
// breathing room) passes className to override. A page that wants a
// non-section element (main, div) should use SiteContainer directly.

import type * as React from 'react'
import { SiteContainer } from './site-container.tsx'
import { cn } from '#app/lib/utils.ts'

export function SiteSection({
	children,
	className,
	wide,
	id,
}: {
	children: React.ReactNode
	className?: string
	wide?: boolean
	id?: string
}) {
	return (
		<SiteContainer
			as="section"
			id={id}
			width={wide ? 'wide' : 'narrow'}
			className={cn('py-6 md:py-8', className)}
		>
			{children}
		</SiteContainer>
	)
}
